import preval from 'preval.macro';

const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;
const GIT_SHA = preval`module.exports = require('child_process').execSync('git rev-parse HEAD').toString().trim().substring(0, 8)`;
const GIT_BRANCH = preval`module.exports = require('child_process').execSync('git rev-parse --abbrev-ref HEAD').toString().trim()`;
const GIT_TAG = preval`module.exports = require('child_process').execSync('git tag --points-at HEAD').toString().trim()`;
const BUILD_TIMESTAMP = preval`module.exports = new Date()`;

type Version = {
  environment: string;
  branch: string;
  tag: string;
  date: Date;
  sha: string;
};

export const getVersion = (): Version => ({
  environment: ENVIRONMENT || 'LOCAL',
  branch: GIT_BRANCH || 'local',
  tag: GIT_TAG,
  sha: GIT_SHA,
  date: new Date(BUILD_TIMESTAMP),
});
